import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated, logout } from "../services/auth";
import { Endpoints } from "../lib/endpoints";
import { HttpCodes } from "../lib/data";
import { PerformRequest } from "../lib/usePerformRequest";
import { NonPaginatedResponse } from "../lib/types";
import { IAdminProps } from "../lib/types/Admin";

export default function RequireAuth({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      // Fast check: no token means straight redirect.
      if (!isAuthenticated()) {
        setAllowed(false);
        setIsChecking(false);
        return;
      }

      // Deep check: validate token with backend to avoid stale tokens.
      const r = await PerformRequest<
        NonPaginatedResponse<IAdminProps> | undefined
      >({
        method: Endpoints.GetProfile().method,
        route: Endpoints.GetProfile().route,
      });

      if (!r || r.status === HttpCodes.Unauthorized) {
        logout();
        setAllowed(false);
      } else {
        setAllowed(true);
      }
      setIsChecking(false);
    };

    verifyAuth().catch(() => {
      logout();
      setAllowed(false);
      setIsChecking(false);
    });
  }, [location.pathname]);

  if (isChecking) {
    return null;
  }

  if (!allowed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
